/* ============================================================
   Men Protocol — Shopify (Dawn) · interactions
   Pricing + Add-to-cart are wired to the section's chosen
   product (see men-protocol.liquid).
   (Subscription removed — one-time purchase only.)
   ============================================================ */
(function () {
  'use strict';

  /* ---- pricing fallback (used only when no product is selected) ---- */
  var PLAN = {
    onetime: { now: 'AED 420', was: 'AED 600', save: 'Save AED 180', off: '30% OFF', meta: 'One-time purchase · free UAE delivery' }
  };
  var plan = 'onetime';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setText(sel, v) { $all(sel).forEach(function (el) { el.textContent = v; }); }

  function applyPlan(p) {
    plan = 'onetime';
    var buys = $all('[data-buy]');
    var buy = null;
    for (var i = 0; i < buys.length; i++) {
      if (buys[i].hasAttribute('data-ot-now')) { buy = buys[i]; break; }
    }
    if (!buy) buy = buys[0];
    var ds = buy ? buy.dataset : {};
    var hasData = !!(buy && buy.hasAttribute('data-ot-now')); /* a product is wired */
    var fb = PLAN.onetime;
    var now  = hasData ? ds.otNow  : fb.now;
    var was  = hasData ? ds.otWas  : fb.was;
    var save = hasData ? ds.otSave : fb.save;
    var off  = hasData ? ds.otOff  : fb.off;
    /* The 30/60-day choice (assets/protocol-plan-picker.js) owns the price once it is on the page */
    var ov = window.__protoPlanOverride;
    if (ov) { now = ov.now; was = ov.was; save = ov.save; off = ov.off; }

    setText('[data-now]', now);     /* men-protocol.liquid LP page */
    setText('[data-mpp-now]', now); /* men-protocol-product.liquid (isolated from Recharge) */
    setText('[data-was]', was);
    setText('[data-mpp-was]', was);
    setText('[data-save]', save);
    setText('[data-mpp-save]', save);
    setText('[data-off]', off);
    setText('[data-mpp-off]', off);
    /* [data-day] / [data-inst] are rendered once by Liquid and left as-is */

    /* sticky bar price is synced automatically via sp-sticky-atc MutationObserver on [data-mpp-now] */
  }

  /* ---- add to cart ----
     If a button carries [data-variant-add] it does a real AJAX add to the
     Shopify cart (/cart/add.js) and refreshes the count from /cart.js.
     Otherwise it falls back to the demo toast (used by non-product buttons). */
  var cart = 0;
  function demoToast(label, btn) {
    cart++;
    $all('[data-cart-ct]').forEach(function (c) { c.textContent = cart; });
    if (btn) { btn.setAttribute('aria-busy', 'true'); setTimeout(function () { btn.removeAttribute('aria-busy'); }, 600); }
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = label || 'Added to cart';
    t.classList.add('show');
    clearTimeout(window.__spToast); window.__spToast = setTimeout(function () { t.classList.remove('show'); }, 2000);
  }
  function showToast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__spToast); window.__spToast = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  function openCart(cart) {
    try {
      /* update BioActive header bag count */
      var cnt = cart ? cart.item_count : 0;
      document.querySelectorAll('.ba-bag-count').forEach(function (el) { el.textContent = cnt; });
      document.querySelectorAll('[data-bac-headcount]').forEach(function (el) { el.textContent = '(' + cnt + ')'; });
      $all('[data-cart-ct]').forEach(function (c) { c.textContent = cnt; });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    } catch (e) {}
    /* open BioActive cart drawer */
    if (typeof window.__bacOpenDrawer === 'function') { window.__bacOpenDrawer(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    ['cart:open', 'drawer:open', 'cart-drawer:open'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
  }

  function realAdd(btn) {
    var id = btn.getAttribute('data-variant-add');
    if (!id) return false;
    var item = { id: parseInt(id, 10), quantity: window.__protoQty || 1 }; /* 2 when "60 days · 2 protocols" is chosen */
    btn.setAttribute('aria-busy', 'true');

    var hasHost = !!document.querySelector('[data-bac-drawer-host]');
    var sections = hasHost ? 'bioactive-cart-drawer' : '';

    var body = { items: [item] };
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (res) {
        /* apply fresh drawer HTML */
        if (res.sections && typeof window.__bacApplySections === 'function') {
          window.__bacApplySections(res.sections);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        openCart(cart);
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
    return true;
  }

  /* ---- timeline stepper ---- */
  var TL = [
    { wk: 'Weeks 1–3', t: 'Recovery kicks in', p: 'Peptides start signalling, astaxanthin buffers training and daily stress, glutathione begins clearing oxidative load. Most men notice steadier energy and easier recovery by day 10–14.', i: 'Habit locked in within 2 weeks', pct: 8 },
    { wk: 'Weeks 4–6', t: 'Energy & drive climb', p: 'Inflammation from training and daily wear recedes. Sleep runs deeper, morning energy gets more reliable, and the skin looks less tired and worn.', i: 'Week 5 — most men commit', pct: 38 },
    { wk: 'Weeks 7–10', t: 'Performance compounds', p: 'All three mechanisms compound at once. Recovery, endurance and definition peak. Collagen density improves at the structural level — joints, tendons and skin all benefit.', i: 'Week 8 — most reviews posted', pct: 68 },
    { wk: 'Week 12', t: 'New baseline', p: 'Joint comfort and elasticity measurably improved, energy steadier, the body more resilient. Each month builds on the last. Most men continue well past 90 days.', i: '90% renew at the 90-day mark', pct: 100 }
  ];
  function setTl(n, container) {
    var ctx = container || document;
    var steps = $all('[data-tl-step]', ctx);
    steps.forEach(function (s, i) { s.classList.toggle('active', i === n); s.classList.toggle('done', i <= n); });
    var fill = $('[data-tl-fill]', ctx); if (fill) { var w = steps.length > 1 ? (n / (steps.length - 1)) * 100 : 0; fill.style.width = 'calc(' + w + '% )'; }
    var d = TL[n]; if (!d) return;
    setText('[data-tl-wk]', d.wk); setText('[data-tl-ttl]', d.t); setText('[data-tl-p]', d.p); setText('[data-tl-i]', d.i);
  }

  /* ---- ingredient tabs ---- */
  function setIng(n) {
    $all('[data-ing]').forEach(function (t) { t.classList.toggle('on', t.dataset.ing === String(n)); });
    $all('[data-ing-panel]').forEach(function (p) { p.classList.toggle('on', p.dataset.ingPanel === String(n)); });
  }

  /* ---- science mechanism infographic tabs ---- */
  function setMechViz(n) {
    $all('[data-mv-tab]').forEach(function (t) { t.classList.toggle('on', t.dataset.mvTab === String(n)); });
    $all('[data-mv-panel]').forEach(function (p) { p.classList.toggle('on', p.dataset.mvPanel === String(n)); });
  }

  /* ---- FAQ ---- */
  function toggleFaq(btn) {
    var item = btn.closest('[data-faq-item]');
    var open = item.classList.contains('open');
    $all('[data-faq-item]').forEach(function (f) { f.classList.remove('open'); });
    if (!open) item.classList.add('open');
  }

  /* ---- review lightbox ---- */
  function openReview(card) {
    setText('[data-rv-handle]', card.dataset.handle);
    setText('[data-rv-cap]', card.dataset.caption);
    setText('[data-rv-views]', card.dataset.views);
    $('[data-rv-modal]').classList.add('show');
    document.body.style.overflow = 'hidden';
  }
  function closeReview() { $('[data-rv-modal]').classList.remove('show'); document.body.style.overflow = ''; }

  /* ---- delivery cadence (kept for any leftover bindings; no-op without freq UI) ---- */
  function setCadence(v) {
    $all('[data-freq-pill]').forEach(function (b) { b.classList.toggle('on', b.dataset.freqPill === v); });
    $all('[data-sb-cadence]').forEach(function (b) { b.classList.toggle('on', b.dataset.sbCadence === v); });
  }

  /* ---- collapsible description (clamp to 2 lines) ---- */
  function initDescClamp() {
    var d = $('[data-desc]'), b = $('[data-desc-toggle]');
    if (!d || !b) return;
    d.classList.add('clamp');
    var overflowing = d.scrollHeight > d.clientHeight + 2;
    b.classList.toggle('show', overflowing);
    if (!overflowing) { b.classList.remove('open'); }
  }
  function toggleDesc(btn) {
    var d = $('[data-desc]'); if (!d) return;
    var clamped = d.classList.toggle('clamp');
    btn.classList.toggle('open', !clamped);
    btn.textContent = clamped ? 'Read more' : 'Read less';
  }

  /* ---- build-a-bundle ---- */
  var BB_PRODUCTS = [
    { id: 'collagen', name: 'Liquid Collagen', price: 197, vial: 'linear-gradient(158deg,#b14a60,#5a1730)' },
    { id: 'asta',     name: 'Astaxanthin',     price: 165, vial: 'linear-gradient(158deg,#2f8163,#0e3d2b)' },
    { id: 'gluta',    name: 'Glutathione',     price: 175, vial: 'linear-gradient(158deg,#e9b8c6,#b8607a)' },
    { id: 'hydra',    name: 'Hyaluronic+',     price: 145, vial: 'linear-gradient(158deg,#79c3c6,#1f6e6a)' },
    { id: 'biotin',   name: 'Hair & Beard',     price: 139, vial: 'linear-gradient(158deg,#e6c878,#9c6f24)' },
    { id: 'vitc',     name: 'Vitamin C+',      price: 149, vial: 'linear-gradient(158deg,#f0a85c,#c2611f)' }
  ];
  var BB_MAX = 4;
  var BB_TIERS = [{ n: 1, off: 0 }, { n: 2, off: .1 }, { n: 3, off: .2 }, { n: 4, off: .3 }];
  var bbPicks = [];

  function fmtAED(n) { return 'AED ' + Math.round(n); }
  function bbProduct(id) { for (var i = 0; i < BB_PRODUCTS.length; i++) { if (BB_PRODUCTS[i].id === id) return BB_PRODUCTS[i]; } }
  function bbTierFor(count) { var t = BB_TIERS[0]; for (var i = 0; i < BB_TIERS.length; i++) { if (count >= BB_TIERS[i].n) t = BB_TIERS[i]; } return t; }
  var CHECK = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function bbInit() {
    var picker = $('[data-bb-picker]');
    if (picker) picker.innerHTML = BB_PRODUCTS.map(function (p) {
      return '<button class="bp" data-bb-pick="' + p.id + '">' +
        '<span class="bp-ct" data-bb-pickct="' + p.id + '" style="display:none">0</span>' +
        '<span class="bp-vial" style="background:' + p.vial + '"></span>' +
        '<span class="bp-n">' + p.name + '</span>' +
        '<span class="bp-p">' + fmtAED(p.price) + '</span></button>';
    }).join('');
    var ms = $('[data-bb-ms]');
    if (ms) ms.innerHTML = BB_TIERS.map(function (t) {
      var left = ((t.n - 1) / (BB_MAX - 1)) * 100;
      var lbl = t.off ? Math.round(t.off * 100) + '%' : 'Pick';
      return '<div class="milestone" data-ms="' + t.n + '" style="left:' + left + '%">' +
        '<div class="ms-dot">' + CHECK + '</div><div class="ms-label">' + lbl + '</div></div>';
    }).join('');
    bbUpdate(false);
  }

  function bbUpdate(animate) {
    var count = bbPicks.length;
    var tier = bbTierFor(count);
    var off = count >= 1 ? tier.off : 0;
    var subtotal = bbPicks.reduce(function (s, id) { return s + bbProduct(id).price; }, 0);
    var saved = Math.round(subtotal * off);
    var total = subtotal - saved;
    var pct = Math.min(100, (count / BB_MAX) * 100);

    var fill = $('[data-bb-fill]'); if (fill) fill.style.width = pct + '%';

    $all('[data-ms]').forEach(function (m) {
      var n = +m.dataset.ms, hit = count >= n, was = m.classList.contains('hit');
      m.classList.toggle('hit', hit);
      if (hit && !was && animate) { m.classList.add('justhit'); setTimeout(function () { m.classList.remove('justhit'); }, 480); }
    });

    var hint = $('[data-bb-hint]');
    if (hint) {
      var next = null; for (var i = 0; i < BB_TIERS.length; i++) { if (BB_TIERS[i].n > count) { next = BB_TIERS[i]; break; } }
      if (count === 0) hint.innerHTML = 'Add a formula to start saving ✨';
      else if (next) hint.innerHTML = 'Add <b>' + (next.n - count) + ' more</b> to unlock <b>' + Math.round(next.off * 100) + '% off</b>';
      else hint.innerHTML = 'Max savings unlocked — <b>30% off</b> 🎉';
    }

    var slots = $('[data-bb-slots]');
    if (slots) {
      var html = '';
      for (var s = 0; s < BB_MAX; s++) {
        var id = bbPicks[s];
        if (id) { var p = bbProduct(id);
          html += '<div class="slot slot-filled' + (animate && s === count - 1 ? ' pop' : '') + '">' +
            '<button class="slot-x" data-bb-remove="' + s + '" aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg></button>' +
            '<span class="slot-vial" style="background:' + p.vial + '"></span><span class="slot-name">' + p.name + '</span></div>';
        } else {
          html += '<div class="slot slot-empty' + (s === count ? ' next' : '') + '"><span class="plus"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg></span></div>';
        }
      }
      slots.innerHTML = html;
    }

    $all('[data-bb-pickct]').forEach(function (el) {
      var pid = el.dataset.bbPickct, n = bbPicks.filter(function (x) { return x === pid; }).length;
      el.style.display = n > 0 ? 'grid' : 'none'; el.textContent = n;
    });
    $all('[data-bb-pick]').forEach(function (b) { b.disabled = count >= BB_MAX; });

    var oc = $('[data-bb-offchip]'); if (oc) { oc.textContent = Math.round(off * 100) + '% off'; oc.classList.toggle('zero', off === 0); }

    var list = $('[data-bb-list]');
    if (list) {
      if (count === 0) list.innerHTML = '<div class="bsum-empty">Your protocol is empty.<br>Tap a formula to start stacking your savings.</div>';
      else list.innerHTML = bbPicks.map(function (id, idx) { var p = bbProduct(id);
        return '<div class="bsum-item"><span class="bi-vial" style="background:' + p.vial + '"></span>' +
          '<span class="bi-n">' + p.name + '</span><span class="bi-p">' + fmtAED(p.price) + '</span>' +
          '<button class="bi-x" data-bb-remove="' + idx + '" aria-label="Remove">✕</button></div>';
      }).join('');
    }

    var rows = $('[data-bb-rows]');
    if (rows) {
      if (count === 0) rows.innerHTML = '';
      else {
        var deliv = total >= 300 ? 'FREE' : fmtAED(25);
        rows.innerHTML = '<div class="bsum-row"><span>' + count + ' formula' + (count > 1 ? 's' : '') + '</span><span class="tnum">' + fmtAED(subtotal) + '</span></div>' +
          (off > 0 ? '<div class="bsum-row save"><span>Bundle discount (' + Math.round(off * 100) + '%)</span><span class="tnum">−' + fmtAED(saved) + '</span></div>' : '') +
          '<div class="bsum-row"><span>Delivery</span><span>' + deliv + '</span></div>' +
          '<div class="bsum-row total"><span class="tl">Total</span><span class="tv tnum">' + fmtAED(total) + '</span></div>';
      }
    }

    var cta = $('[data-bb-add]'), ctaTxt = $('[data-bb-cta]');
    if (cta) cta.disabled = count === 0;
    if (ctaTxt) ctaTxt.textContent = count === 0 ? 'Add a formula' : 'Add protocol — ' + fmtAED(total);
  }

  function bbPick(id) { if (bbPicks.length >= BB_MAX) return; bbPicks.push(id); bbUpdate(true); }
  function bbRemove(i) { bbPicks.splice(i, 1); bbUpdate(false); }
  function bbAddToCart() {
    if (!bbPicks.length) return;
    var count = bbPicks.length, tier = bbTierFor(count);
    cart += count; $all('[data-cart-ct]').forEach(function (c) { c.textContent = cart; });
    var btn = $('[data-bb-add]'); if (btn) { btn.setAttribute('aria-busy', 'true'); setTimeout(function () { btn.removeAttribute('aria-busy'); }, 600); }
    var t = $('[data-toast]'); if (t) { t.textContent = 'Protocol added — ' + Math.round(tier.off * 100) + '% off ✓'; t.classList.add('show'); clearTimeout(window.__spToast); window.__spToast = setTimeout(function () { t.classList.remove('show'); }, 2000); }
    bbPicks = []; bbUpdate(false);
  }

  /* ---- bottom sticky bar (appears once hero buy box scrolls out) ---- */
  function initSticky() {
    var buy = $('[data-buy]'); var bar = $('[data-stickybar]');
    if (!buy || !bar) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle('show', !en[0].isIntersecting);
      }, { rootMargin: '0px 0px -60% 0px' }).observe(buy);
    }
  }

  /* ---- announcement ticker ---- */
  function initTicker() {
    var msgs = $all('[data-announce-msg]'); if (msgs.length < 2) return;
    var i = 0; msgs[0].classList.add('on');
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 3200);
  }

  /* ---- reveal on scroll ---- */
  function initReveal() {
    var els = $all('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- smooth scroll to buy ---- */
  function scrollToBuy() {
    var el = $('[data-buy]') || $('#hero');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }

  /* ---- delegated clicks ---- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-desc-toggle]'))) toggleDesc(t);
    else if ((t = e.target.closest('[data-mech-toggle]'))) {
      var card = t.closest('.mech-card'); if (!card) return;
      var open = card.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.childNodes[0].nodeValue = open ? 'Read less' : 'Read more';
    }
    else if ((t = e.target.closest('[data-bb-pick]'))) bbPick(t.dataset.bbPick);
    else if ((t = e.target.closest('[data-bb-remove]'))) { e.stopPropagation(); bbRemove(+t.dataset.bbRemove); }
    else if ((t = e.target.closest('[data-bb-add]'))) bbAddToCart();
    /* The sticky bar's [data-add] has its own add-to-cart (sections/sp-sticky-atc) — skip it here,
       otherwise it could also fire the demo toast and bump the bag count by a fake +1. */
    else if ((t = e.target.closest('[data-add]')) && !t.closest('[data-stickybar]')) { e.preventDefault(); if (!realAdd(t)) demoToast(t.dataset.add, t); }
    else if ((t = e.target.closest('[data-scroll-buy]'))) { e.preventDefault(); scrollToBuy(); }
    else if ((t = e.target.closest('[data-tl-step]'))) setTl(+t.dataset.tlStep, t.closest('.tl') || document);
    else if ((t = e.target.closest('[data-thumb]'))) { setPic($all('[data-thumb]').indexOf(t)); }
    else if ((t = e.target.closest('[data-gal-dot]'))) { setPic($all('[data-gal-dot]').indexOf(t)); }
    else if ((t = e.target.closest('[data-gal-seg]'))) { setPic($all('[data-gal-seg]').indexOf(t)); }
    else if (e.target.closest('[data-gal-prev]')) { setPic(galIndex - 1); }
    else if (e.target.closest('[data-gal-next]')) { setPic(galIndex + 1); }
    else if ((t = e.target.closest('[data-ing]'))) setIng(t.dataset.ing);
    else if ((t = e.target.closest('[data-mv-tab]'))) setMechViz(t.dataset.mvTab);
    else if ((t = e.target.closest('[data-faq]'))) toggleFaq(t);
    else if ((t = e.target.closest('[data-review]'))) openReview(t);
    else if (e.target.closest('[data-rv-close]') || e.target === $('[data-rv-modal]')) closeReview();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReview(); });

  /* ---- hero gallery: thumbnails (desktop) + swipe (mobile) ---- */
  var galIndex = 0;
  function setPic(i) {
    var thumbs = $all('[data-thumb]');
    if (!thumbs.length) return;
    i = (i + thumbs.length) % thumbs.length;
    galIndex = i;
    var th = thumbs[i];
    thumbs.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    $all('[data-gal-dot]').forEach(function (d, k) { d.classList.toggle('on', k === i); });
    $all('[data-gal-seg]').forEach(function (s, k) { s.classList.toggle('on', k === i); });
    var ph = $('[data-gal-stage]');
    if (ph) {
      ph.classList.remove('pic-green', 'pic-terra', 'pic-pink');
      if (th.classList.contains('g2')) ph.classList.add('pic-green');
      else if (th.classList.contains('g3')) ph.classList.add('pic-terra');
      else if (th.classList.contains('g4')) ph.classList.add('pic-pink');
      var lab = th.querySelector('.ph');
      ph.setAttribute('data-label', lab ? lab.textContent : '');
    }
    // real media slides
    $all('[data-gal-stage-media]').forEach(function (sl, k) { sl.classList.toggle('on', k === i); });
    var main = $('[data-gal-main]');
    if (main) main.classList.toggle('not-hero', i !== 0);
  }
  function initGallery() {
    var main = $('[data-gal-main]');
    if (!main) return;
    var startX = null, startY = null, dragging = false;
    main.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; dragging = true;
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return; dragging = false;
      if (startX == null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) setPic(galIndex + (dx < 0 ? 1 : -1));
      startX = startY = null;
    });
    // cap the vertical thumb rail to the picture height (desktop row layout only)
    var rail = $('.gal-thumbs');
    function syncRail() {
      if (!rail) return;
      if (window.innerWidth > 1000) rail.style.maxHeight = main.offsetHeight + 'px';
      else rail.style.maxHeight = '';
    }
    syncRail();
    window.addEventListener('resize', function () { clearTimeout(window.__railRz); window.__railRz = setTimeout(syncRail, 150); });
    window.addEventListener('load', syncRail);

    // horizontal trackpad scroll over the picture changes the shot (vertical scroll still scrolls the page)
    var wheelLock = false;
    main.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) < 24 || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      setPic(galIndex + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 360);
    }, { passive: false });
  }

  function initClamp() {
    $all('[data-clamp-toggle]').forEach(function (btn) {
      var target = btn.parentNode.querySelector('[data-clamp]');
      if (!target) return;
      btn.addEventListener('click', function () {
        var nowClamped = target.classList.toggle('clamped');
        var lbl = btn.querySelector('[data-clamp-lbl]');
        if (lbl) lbl.textContent = nowClamped ? 'Read more' : 'Read less';
        btn.classList.toggle('open', !nowClamped);
        btn.setAttribute('aria-expanded', String(!nowClamped));
      });
    });
  }

  function boot() {
    applyPlan('onetime'); setTl(0); setIng(1);
    initSticky(); initTicker(); initReveal(); bbInit();
    initDescClamp(); initGallery(); initClamp();
    window.addEventListener('resize', function () { clearTimeout(window.__descRz); window.__descRz = setTimeout(initDescClamp, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
